/* Runtime du clone — remplace les scripts du concurrent (retirés au build).
   Tout est scopé sous .tc-clone. Aucune dépendance externe. */
(function () {
  var root = document.querySelector('.tc-clone');
  if (!root) return;

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  /* ---------------------------------------------------------------- FAQ */
  function initFaq() {
    $$('.faq-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-target');
        $$('.faq-tab').forEach(function (t) { t.classList.toggle('active', t === tab); });
        $$('.faq-section').forEach(function (s) { s.classList.toggle('active', s.id === target); });
      });
    });

    $$('.faq-item').forEach(function (item) {
      var q = $('.faq-question', item);
      if (!q) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('open');
        // accordéon : une seule réponse ouverte par section
        var section = item.closest('.faq-section') || root;
        $$('.faq-item.open', section).forEach(function (o) { o.classList.remove('open'); });
        if (!open) item.classList.add('open');
        var icon = $('.faq-toggle-icon', item) || $('.faq-toggle', item);
        $$('.faq-item', section).forEach(function (o) {
          var ic = $('.faq-toggle-icon', o) || $('.faq-toggle', o);
          if (ic) ic.textContent = o.classList.contains('open') ? '−' : '+';
        });
        if (icon) icon.textContent = item.classList.contains('open') ? '−' : '+';
      });
    });
  }

  /* --------------------------------------------- accordéons génériques */
  /* Les blocs Dawn sont des <details> natifs : rien à faire.
     On ne traite que les entêtes custom qui pilotent un panneau caché.   */
  function initGenericAccordions() {
    $$('.product__accordion').forEach(function (acc) {
      if (acc.tagName.toLowerCase() === 'details') return; // natif
      var head = $('.accordion__summary, .accordion__title', acc);
      var body = $('.accordion__content-wrapper, .accordion__content', acc);
      if (!head || !body || head.closest('details')) return;
      body.style.overflow = 'hidden';
      body.style.transition = 'max-height .3s';
      body.style.maxHeight = '0px';
      head.style.cursor = 'pointer';
      head.addEventListener('click', function () {
        var open = body.style.maxHeight !== '0px';
        body.style.maxHeight = open ? '0px' : body.scrollHeight + 'px';
      });
    });
  }

  /* ---------------------------------------------------------- carrousels */
  function makeScrollable(track, list, slides) {
    if (list) { list.style.transform = 'none'; list.style.display = 'flex'; list.style.width = 'auto'; }
    track.style.overflowX = 'auto';
    track.style.scrollSnapType = 'x mandatory';
    track.style.scrollBehavior = 'smooth';
    track.style.webkitOverflowScrolling = 'touch';
    track.style.scrollbarWidth = 'none';
    slides.forEach(function (s) { s.style.scrollSnapAlign = 'start'; s.style.flex = '0 0 auto'; });
  }

  function initSplide() {
    $$('.splide').forEach(function (sp) {
      var track = $('.splide__track', sp);
      var list = $('.splide__list', sp);
      if (!track || !list) return;

      // les clones de boucle feraient doublon sans le JS de Splide
      $$('.splide__slide--clone', sp).forEach(function (c) { c.remove(); });
      var slides = $$('.splide__slide', sp);
      if (!slides.length) return;
      makeScrollable(track, list, slides);

      var step = function () { return slides[0].getBoundingClientRect().width + 16; };
      var prev = $('.splide__arrow--prev', sp);
      var next = $('.splide__arrow--next', sp);
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); track.scrollLeft -= step(); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); track.scrollLeft += step(); });

      var dots = $$('.splide__pagination__page', sp);
      dots.forEach(function (d, i) {
        d.addEventListener('click', function (e) {
          e.preventDefault();
          if (slides[i]) track.scrollLeft = slides[i].offsetLeft - slides[0].offsetLeft;
        });
      });
      if (dots.length) {
        track.addEventListener('scroll', function () {
          var idx = Math.round(track.scrollLeft / step());
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        });
      }
    });
  }

  /* ------------------------------------------------------------ galerie */
  function initGallery() {
    var list = $('.product__media-list');
    if (!list) return;
    var media = $$('li', list).filter(function (li) { return li.querySelector('img, video'); });
    if (media.length < 2) return;

    list.style.overflowX = 'auto';
    list.style.scrollSnapType = 'x mandatory';
    list.style.scrollBehavior = 'smooth';
    list.style.scrollbarWidth = 'none';
    media.forEach(function (m) { m.style.scrollSnapAlign = 'center'; });

    var goTo = function (i) {
      var el = media[i];
      if (!el) return;
      list.scrollLeft = el.offsetLeft - list.offsetLeft;
      thumbs.forEach(function (t, j) {
        var btn = t.querySelector('button, .thumbnail');
        if (btn) btn.setAttribute('aria-current', j === i ? 'true' : 'false');
        t.classList.toggle('is-active', j === i);
      });
    };

    var thumbs = $$('.thumbnail-list li, [class*="thumbnail-list"] li');
    thumbs.forEach(function (t, i) {
      t.style.cursor = 'pointer';
      t.addEventListener('click', function (e) { e.preventDefault(); goTo(i); });
    });

    $$('.slider-button--prev').forEach(function (b) {
      if (b.closest('.splide')) return;
      b.addEventListener('click', function (e) { e.preventDefault(); list.scrollLeft -= media[0].getBoundingClientRect().width; });
    });
    $$('.slider-button--next').forEach(function (b) {
      if (b.closest('.splide')) return;
      b.addEventListener('click', function (e) { e.preventDefault(); list.scrollLeft += media[0].getBoundingClientRect().width; });
    });
    goTo(0);
  }

  /* -------------------------------------------- variantes & panier */
  var PRODUCT = window.TC_PRODUCT || null;

  function radiosFor(keyword) {
    var all = $$('input[type="radio"]');
    var hit = all.filter(function (r) {
      return (r.name || '').toLowerCase().indexOf(keyword) !== -1;
    });
    return hit;
  }

  function initVariants() {
    var form = $('form[action*="/cart/add"]');
    if (!form || !PRODUCT || !PRODUCT.variants) return;

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var colors = radiosFor('couleur');
    var sizes = radiosFor('taille');
    var stickySelect = $('.sticky-atc__variant-select');

    // toute référence au produit du concurrent est purgée du formulaire
    $$('input[name="product-id"], input[name="section-id"], input[name^="properties[__kaching"]', form)
      .forEach(function (i) { i.remove(); });

    // un groupe de radios cloné n'a de sens que si le produit porte l'option
    var optionNames = (PRODUCT.options || []).map(function (o) {
      return String(o && o.name ? o.name : o).toLowerCase();
    });
    function productHasOption(word) {
      return optionNames.some(function (n) { return n.indexOf(word) !== -1; });
    }
    function hideGroup(radios) {
      var box = radios[0] && (radios[0].closest('fieldset') || radios[0].closest('.product-form__input'));
      if (box) box.style.display = 'none';
    }
    // Kaching affiche ses propres sélecteurs de variante dans chaque offre :
    // ceux du clone feraient doublon juste au-dessus.
    var kachingBlock = document.querySelector('kaching-bundles-block');
    if (kachingBlock) {
      [colors, sizes].forEach(function (g) {
        var box = g[0] && (g[0].closest('fieldset') || g[0].closest('.product-form__input'));
        if (box) box.remove();
      });
      colors = []; sizes = [];
    } else {
      if (colors.length && !productHasOption('couleur')) { hideGroup(colors); colors = []; }
      if (sizes.length && !productHasOption('taille')) { hideGroup(sizes); sizes = []; }
    }

    function resolve() {
      // on matche sur les valeurs cochées, quel que soit le nombre d'options
      var picked = [];
      [colors, sizes].forEach(function (g) {
        var r = g.filter(function (x) { return x.checked; })[0];
        if (r) picked.push(r.value);
      });
      var v = PRODUCT.variants.filter(function (x) {
        var vals = [x.option1, x.option2, x.option3].filter(Boolean);
        return vals.length && vals.every(function (o) { return picked.indexOf(o) !== -1; });
      })[0] || PRODUCT.variants[0];
      if (idInput) idInput.value = v.id;
      if (stickySelect) {
        var want = (v.option1 || '') + (v.option2 ? ',' + v.option2 : '');
        Array.prototype.forEach.call(stickySelect.options, function (o) {
          if (o.value === want) stickySelect.value = o.value;
        });
      }
      return v;
    }

    colors.concat(sizes).forEach(function (r) { r.addEventListener('change', resolve); });

    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        var parts = stickySelect.value.split(',');
        colors.forEach(function (r) { r.checked = (r.value === parts[0]); });
        sizes.forEach(function (r) { r.checked = (r.value === parts[1]); });
        resolve();
      });
    }

    // Les barres d'offre clonées portent la config Kaching DU CONCURRENT : elles
    // affichent un prix de lot mais aucune remise ne peut s'appliquer chez nous,
    // donc le panier facturait le plein tarif × la quantité. On les retire et on
    // laisse l'app Kaching de la boutique injecter ses vraies offres.
    $$('kaching-bundles-block, .kaching-bundles').forEach(function (el) { el.remove(); });

    // les blocs d'app rendus par la section descendent à l'emplacement des offres
    var host = document.getElementById('tc-app-blocks');
    var slot = document.getElementById('tc-bundle-slot');
    if (host && slot && host.children.length) {
      host.removeAttribute('hidden');
      while (host.firstChild) slot.appendChild(host.firstChild);
    }
    if (window.kachingBundlesEnabled && typeof window.kachingBundlesInitialize === 'function') {
      try { window.kachingBundlesInitialize(); } catch (e) {}
    }
    if (qtyInput) qtyInput.value = 1;

    var deals = $$('input[type="radio"][name^="kaching-bundles-deal"]');
    var QTY = [1, 2]; // 1 acheté · 1 acheté = 1 gratuit
    var bars = $$('.kaching-bundles__bar');
    deals.forEach(function (d, i) {
      var apply = function () {
        if (qtyInput) qtyInput.value = QTY[i] || 1;
        bars.forEach(function (bar, j) {
          bar.classList.toggle('kaching-bundles__bar--selected', j === i);
        });
      };
      d.addEventListener('change', apply);
      var label = d.closest('label') || d.parentElement;
      if (label) label.addEventListener('click', function () { d.checked = true; apply(); });
      if (d.checked) apply();
    });
    if (deals.length && !deals.some(function (d) { return d.checked; })) {
      // repartir de l'offre que le concurrent présélectionnait visuellement
      var pre = bars.map(function (b) { return b.classList.contains('kaching-bundles__bar--selected'); }).indexOf(true);
      if (pre < 0) pre = 0;
      deals[pre].checked = true;
      if (qtyInput) qtyInput.value = QTY[pre] || 1;
    }

    resolve();

    // ajout AJAX + ouverture du drawer UpCart (sinon on retombe sur /cart)
    var busy = false;
    function addToCart(e) {
      if (e) e.preventDefault();
      if (busy) return;
      busy = true;
      resolve();
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart/add ' + r.status);
          return r.json();
        })
        .then(function () {
          if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
          if (typeof window.upcartOpenCart === 'function') {
            window.upcartOpenCart();
          } else {
            document.dispatchEvent(new CustomEvent('upcart:open'));
            window.location.href = '/cart';
          }
        })
        .catch(function () { form.submit(); })
        .then(function () { busy = false; });
    }

    // Quand Kaching pilote l'offre, c'est lui qui gère variante, quantité et
    // remise : on ne touche plus au formulaire, sinon les deux se marchent dessus.
    if (kachingBlock) return;

    form.addEventListener('submit', addToCart);
    $$('.sticky-atc__add_button, .main-product-atc').forEach(function (b) {
      if (b.type === 'submit' && b.form === form) return;
      b.addEventListener('click', addToCart);
    });
  }

  /* --------------------------------------------- compte à rebours + dates */
  function initTimer() {
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };

    // deux gabarits selon le bloc d'origine : « 12MIN 55SEC » ou « 08:45:04 »
    var run = function (el, minutes, render) {
      var KEY = 'tc_deadline_' + minutes;
      var end = parseInt(sessionStorage.getItem(KEY) || '0', 10);
      if (!end || end < Date.now()) {
        end = Date.now() + minutes * 60 * 1000;
        sessionStorage.setItem(KEY, String(end));
      }
      (function tick() {
        var left = Math.max(0, end - Date.now());
        el.textContent = render(left);
        if (left > 0) setTimeout(tick, 1000);
      })();
    };

    var short = root.querySelector('[id$="-timer-v2"]');
    if (short) {
      run(short, 15, function (l) {
        return Math.floor(l / 60000) + 'MIN ' + pad(Math.floor((l % 60000) / 1000)) + 'SEC';
      });
    }

    $$('.kaching-bundles__timer-value').forEach(function (el) {
      run(el, 8 * 60 + 45, function (l) {
        return pad(Math.floor(l / 3600000)) + ':' + pad(Math.floor((l % 3600000) / 60000)) + ':' + pad(Math.floor((l % 60000) / 1000));
      });
    });
  }

  function initDates() {
    var MOIS = ['Janv.', 'Févr.', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'];
    var fmt = function (d) {
      return ('0' + d.getDate()).slice(-2) + ' ' + MOIS[d.getMonth()] + '.';
    };
    var plus = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };

    var boxes = $$('.content-box__step-box');
    var texts = [fmt(new Date()), fmt(plus(1)) + ' - ' + fmt(plus(3)), fmt(plus(6)) + ' - ' + fmt(plus(9))];
    boxes.forEach(function (b, i) {
      var span = b.querySelector('.date__sub-content span') || b.querySelector('.date__sub-content');
      if (span && texts[i]) span.textContent = texts[i];
    });

    // « Livraison estimée entre le X et le Y »
    $$('p, span').forEach(function (n) {
      if (n.children.length === 0 && /Livraison estimée entre le/.test(n.textContent)) {
        n.textContent = 'Livraison estimée entre le ' + fmt(plus(6)) + ' et le ' + fmt(plus(9)) + '.';
      }
    });
  }

  /* --------------------------------------------------- guide des tailles */
  function initSizeGuide() {
    $$('a, button').forEach(function (el) {
      var t = (el.textContent || '').trim().toLowerCase();
      if (t !== 'guide des tailles') return;
      el.addEventListener('click', function (e) {
        var target = $$('summary, .accordion__summary').filter(function (s) {
          return /guide des tailles/i.test(s.textContent || '');
        })[0];
        if (!target) return;
        e.preventDefault();
        var det = target.closest('details');
        if (det) det.open = true;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  function boot() {
    try { initFaq(); } catch (e) {}
    try { initGenericAccordions(); } catch (e) {}
    try { initSplide(); } catch (e) {}
    try { initGallery(); } catch (e) {}
    try { initVariants(); } catch (e) {}
    try { initTimer(); } catch (e) {}
    try { initDates(); } catch (e) {}
    try { initSizeGuide(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
